import React from 'react';
import BaseComponent from 'components/BaseComponent';
import { memberId$, unreadMessageCount$ } from 'services/subjects';
import { getHasUnread } from 'components/pages/MessageCenter';
import { FEATURE_FLAGS } from 'common/constants';
import { fetchInteractions$, messageService } from 'services/messageService';

export default function withInteractionData(WrappedComponent) {
    return class extends BaseComponent {
        constructor(props) {
            super(props);
            this.fetchStarted = false;

            this.state = {};
            this.currentMemberSubscription = null;
            this.currentInteractionsSubscription = null;
        }

        cleanupSubscriptions = () => {
            this.currentMemberSubscription?.unsubscribe();
            this.currentInteractionsSubscription?.unsubscribe();
        }

        componentDidMount = () => {
            if (
                this.props.featureFlags &&
                this.props.featureFlags[FEATURE_FLAGS.crmInteractionMessageCenter]
            ) {
                this.cleanupSubscriptions();
                this.beginFetch();
            }
        };

        componentDidUpdate = () => {
            if (
                !this.fetchStarted &&
                this.props.featureFlags &&
                this.props.featureFlags[FEATURE_FLAGS.crmInteractionMessageCenter]
            ) {
                this.cleanupSubscriptions();
                this.beginFetch();
            }
        };

        componentWillUnmount = () => {
            super.componentWillUnmount();
            this.cleanupSubscriptions();
        };

        beginFetch = () => {
            this.fetchStarted = true;
            this.currentMemberSubscription = memberId$.subscribe((memberId) => this.setState({ memberId }));
            this.currentInteractionsSubscription = messageService.interactions$.subscribe({ next: (response) => {
                this.handleInteractionsResponse(response);
            } , error: console.error });
        };

        refreshInteractions = () => {
            fetchInteractions$.next();
        };

        handleInteractionsResponse = (interactions) => {
            this.setState({ interactions });
            if (interactions) {
                const hasUnreadInteractions = interactions.filter((interaction) =>
                    getHasUnread(interaction, this.state.memberId)
                );
                unreadMessageCount$.next(hasUnreadInteractions.length);
            }
        };

        render() {
            return (
                <WrappedComponent
                    interactions={this.state.interactions}
                    refreshInteractions={this.refreshInteractions}
                    {...this.props}
                />
            );
        }
    };
}
